import { createSelector } from 'reselect';
import {
  getBranchesAddresses,
  getBranchesOptions,
} from '../../CompanySettings/utils';
import {
  getIsBetween,
  mapEmployerToTable,
  formatStringToFirstLetterCapital,
} from '../utils';

export const selectEmployees = (state) => state.employeesReducer?.employeesList;
export const selectAllEmployees = (state) =>
  state.employeesReducer?.allEmployeesList;

export const selectFiltersObject = (state) => state.employeesReducer?.filters;

export const selectSearchTerm = (state) => state.employeesReducer?.searchTerm;

export const selectCompanyBranches = (state) =>
  state.employeesReducer?.companyBranches;

export const selectDateRangeObject = (state) =>
  state.employeesReducer?.dateRange;

export const selectEmployeesStatus = (state) => state.employeesReducer?.status;

export const selectLastSyncTime = (state) =>
  state.employeesReducer?.lastSyncTime;

export const selectLastSyncingStatus = (state) =>
  state.employeesReducer?.lastSyncingStatus;

export const selectEmployeePagination = (state) => ({
  currentPage: state.employeesReducer.currentPage,
  pages: state.employeesReducer.pages,
  limit: state.employeesReducer.limit,
  total: state.employeesReducer.total,
});

export const selectCompanyBranchesOptions = createSelector(
  [selectCompanyBranches],
  (branches) => {
    if (branches && branches.length) {
      return getBranchesOptions(branches);
    }
    return [];
  }
);

export const selectBranchesAddresses = createSelector(
  [selectCompanyBranches],
  (branches) => {
    if (branches && branches.length) {
      return getBranchesAddresses(branches);
    }
    return {};
  }
);

export const selectFilters = (state) => {
  const filters = selectFiltersObject(state);
  if (filters?.toJS) {
    return filters;
  }
  return filters;
};

export const selectDateRange = (state) => {
  const dateRangeObject = selectDateRangeObject(state);
  if (dateRangeObject?.toJS) {
    return dateRangeObject;
  }
  return dateRangeObject;
};

export const selectIsFilterChosen = createSelector(
  [selectFilters, selectSearchTerm],
  (filters, searchTerm) => {
    const isFilters =
      Object.values(filters).filter((value) => value !== '').length > 0;
    return isFilters || searchTerm.length > 0;
  }
);

export const selectEmployeesInsideSelectedDateRange = createSelector(
  [selectAllEmployees, selectDateRange],
  (employees, dateRange) => {
    console.log(employees, dateRange);
    return employees.filter((item) =>
      getIsBetween(item.startdate, item.enddate, dateRange)
    );
  }
);

export const selectNatureEmploymentOptions = createSelector(
  [selectEmployeesInsideSelectedDateRange],
  (employees) => {
    const natureEmploymentsArray = [...employees].map(({ employeeposition }) =>
      formatStringToFirstLetterCapital(employeeposition)
    );
    const uniqueNatureEmployments = Array.from(new Set(natureEmploymentsArray));

    return uniqueNatureEmployments.map((item) => ({
      value: item,
      label: item,
    }));
  }
);

export const selectClassificationOptions = createSelector(
  [selectEmployeesInsideSelectedDateRange],
  (employees) => {
    const classificationsArray = [...employees].map(
      ({ classification }) => classification
    );
    const uniqueClassifications = Array.from(new Set(classificationsArray));

    return uniqueClassifications.map((item) => ({
      value: item,
      label: item,
    }));
  }
);

export const selectContractOptions = createSelector(
  [selectEmployeesInsideSelectedDateRange],
  (employees) => {
    const contractsArray = [...employees]
      .map(({ typecontract }) => typecontract)
      .filter((contract) => !!contract);
    const uniqueContractsArray = Array.from(new Set(contractsArray));

    return uniqueContractsArray.map((item) => ({
      value: item,
      label: item,
    }));
  }
);

export const selectFilteredEmployees = createSelector(
  [selectEmployees, selectBranchesAddresses],
  (employees, branchAddresses) => {
    const mappedEmployees = mapEmployerToTable([...employees], branchAddresses);

    return mappedEmployees;
  }
);

export const selectIsWaitingModalShow = (state) =>
  state.employeesReducer?.isWaitingModalShow;

export const selectIsSingleWaitingModalShow = (state) =>
  state.employeesReducer?.isSingleWaitingModalShow;
